export interface DependentsExportInterface {
  id?: number;
  attribute: string;
  text: string;
  reportType: string;
}

export let DependentsExport: DependentsExportInterface[] = [
  { attribute: 'id', text: 'Número do Título', reportType: 'DEPENDENTS' },
  { attribute: 'status', text: 'Status', reportType: 'DEPENDENTS' },
  { attribute: 'name', text: 'Nome', reportType: 'DEPENDENTS' },
  { attribute: 'phone', text: 'Telefone', reportType: 'DEPENDENTS' },
  { attribute: 'dependents', text: 'Dependentes', reportType: 'DEPENDENTS' }
];